module.exports = __webpack_public_path__ + "public/images/icons/plane.80bfe8230ed3567ec218ac4a808dcb7c.png";